<script>
    export let title = "";
</script>

<div class="form-group">
    <span class="col-sm-3 control-label"><strong>{title}</strong></span>
</div>
